export default __webpack_public_path__ + "static/media/conginment.279a711c.svg";